import React from 'react';
import i18n from 'i18next';

import { addModal, GroupsEligibleMembersContainer } from '@/exceed';

export default ({ name, groupId }) => {
  const actions = [
    {
      action: 'cancel',
      color: 'brand',
      element: 'button',
      text: i18n.t('close'),
    },
  ];
  return addModal({
    actions,
    title: `${name} ${i18n.t('members')}`,
    body: i18n.t('eligible-members-body'),
    hasCloseButton: true,
    component: <GroupsEligibleMembersContainer groupId={groupId} type="user" emptyStateText={i18n.t('groups-members-empty-state')} />,
  });
};
